/**
 * price-note-fit.js
 * Haelt den USt-Preishinweis (.product__price-note, .price__tax-suffix) einzeilig:
 * 1) versucht eine Zeile (nowrap), 2) verkleinert die Schrift bei Platzmangel,
 * 3) bricht nur als letzter Ausweg um -> laeuft nie aus dem Bild.
 *
 * LAZY: fittet jede Notiz erst wenn sie sichtbar wird (IntersectionObserver),
 * nicht alle auf einmal bei Load/Resize. Verhindert Reflow-Stuerme bei vielen
 * Notizen (z. B. Mega-Menu). Eigenstaendig, kein Eingriff in main.js.
 */
(function () {
  var SELECTOR = '.product__price-note, .price__tax-suffix';
  var MIN_RATIO = 0.62; // Schrift nicht kleiner als 62 % der Ausgangsgroesse

  function fitOne(el) {
    if (!el || !el.parentElement) return;
    // Unsichtbare (z. B. in geschlossenen Mega-Menu-Panels) nicht vermessen.
    if (el.offsetParent === null && el.getClientRects().length === 0) return;
    el.style.whiteSpace = 'nowrap';
    el.style.fontSize = '';
    var base = parseFloat(window.getComputedStyle(el).fontSize) || 12;
    var min = base * MIN_RATIO;
    var size = base;
    var guard = 60;
    while (el.scrollWidth > el.clientWidth && size > min && guard-- > 0) {
      size -= 0.5;
      el.style.fontSize = size + 'px';
    }
    el.style.whiteSpace = el.scrollWidth > el.clientWidth ? 'normal' : 'nowrap';
  }

  var io = ('IntersectionObserver' in window)
    ? new IntersectionObserver(function (entries) {
        for (var i = 0; i < entries.length; i++) {
          if (entries[i].isIntersecting) {
            fitOne(entries[i].target);
            io.unobserve(entries[i].target); // einmalig genuegt
          }
        }
      }, { rootMargin: '150px' })
    : null;

  function observeAll() {
    var nodes = document.querySelectorAll(SELECTOR);
    for (var i = 0; i < nodes.length; i++) {
      if (io) io.observe(nodes[i]); else fitOne(nodes[i]);
    }
  }

  var t;
  function schedule() { clearTimeout(t); t = setTimeout(function () {
    if (io) { io.disconnect(); }
    observeAll(); // sichtbare werden erneut gefittet, unsichtbare bleiben guenstig
  }, 150); }

  if (document.readyState !== 'loading') observeAll();
  document.addEventListener('DOMContentLoaded', observeAll);
  window.addEventListener('resize', schedule);

  // Nach Variantenwechsel wird #price-... neu gerendert -> neu beobachten.
  var priceBlocks = document.querySelectorAll('[id^="price-"]');
  for (var j = 0; j < priceBlocks.length; j++) {
    new MutationObserver(schedule).observe(priceBlocks[j], { childList: true, subtree: true });
  }
})();
